import Cookies from 'js-cookie'
import axios from 'axios'
import { cookieOptions } from 'utils'

axios.defaults.baseURL = process.env.REACT_APP_API
axios.defaults.headers.common['Content-Type'] = 'application/json'

const accessToken = Cookies.get('adminAccessToken')
axios.defaults.headers.common['Authorization'] = accessToken
  ? `Bearer ${accessToken}`
  : ''

export const AUTHORIZATION_ERROR_EVENT = 'admin:authorization-error'

export const clearAuthData = () => {
  Cookies.remove('adminAccessToken', cookieOptions)
  Cookies.remove('adminRefreshToken', cookieOptions)
  Cookies.remove('accessToken', cookieOptions)
  Cookies.remove('refreshToken', cookieOptions)
  delete axios.defaults.headers.common['Authorization']
  localStorage.clear()
}

const isAuthorizationError = (error: unknown) => {
  if (typeof error !== 'object' || error === null || !('response' in error)) {
    return false
  }

  const status = (error as { response?: { status?: number } }).response?.status
  return status === 401 || status === 403
}

axios.interceptors.response.use(
  response => response,
  error => {
    if (isAuthorizationError(error)) {
      error.isAuthorizationError = true
      window.dispatchEvent(new Event(AUTHORIZATION_ERROR_EVENT))
    }

    return Promise.reject(error)
  }
)

export { axios }
